
<dx-form [(formData)]="filters" [colCount]="4" labelLocation="top">

  <!-- Date Start -->
  <dxi-item dataField="dateStart" dataType="date" [isRequired]="false">
    <dxo-label text="Fecha Inicio"></dxo-label>
    <dx-date-box displayFormat="shortdate" type="date" [(value)]="filters.dateStart" (onValueChanged)="getDispersions($event)">
      <dx-validator>
        <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
      </dx-validator>
    </dx-date-box>
  </dxi-item>

  <!-- Date End -->
  <dxi-item dataField="dateEnd" dataType="date" [isRequired]="false">
    <dxo-label text="Fecha Fin"></dxo-label>
    <dx-date-box displayFormat="shortdate" type="date" [(value)]="filters.dateEnd" (onValueChanged)="getDispersions($event)">
      <dx-validator>
        <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
      </dx-validator>
    </dx-date-box>
  </dxi-item>

</dx-form>


<dx-data-grid [dataSource]="dispersions" keyExpr="id" [showBorders]="true" [columnAutoWidth]="true" (onRowPrepared)="onRowPrepared($event)">
  <!-- Others -->
  <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="Reporte de Movimientos ihunter"></dxo-export>
  <dxo-load-panel [enabled]="true"></dxo-load-panel>

  <!-- Paginacion -->
  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true"></dxo-pager>

  <!-- Columns -->
  <dxi-column dataField="dispersion" caption="No." alignment="center" cellTemplate="posTemplate" name="pos" width="auto"></dxi-column>
  <dxi-column dataField="dispersion" caption="ID" alignment="center" cellTemplate="idTemplate" name="id" width="auto"></dxi-column>
  <dxi-column dataField="dispersion" caption="Tipo" alignment="center" cellTemplate="tipoTemplate" name="tipo" width="auto"></dxi-column>
  <dxi-column dataField="dispersion" caption="Fecha Registro" alignment="center" cellTemplate="dateCreatedTemplate" name="dateCreated" width="auto"></dxi-column>
  <dxi-column dataField="dispersion" caption="Fecha Programada" alignment="center" cellTemplate="dateScheduledTemplate" name="dateScheduled" width="auto"></dxi-column>
  <dxi-column dataField="dispersion" caption="Fecha Ejecución" alignment="center" cellTemplate="dateExecutedTemplate" name="dateExecuted" width="auto"></dxi-column>
  <!--
  <dxi-column dataField="Tarjeta" caption="Tarjeta" alignment="left" cellTemplate="TarjetaTemplate"></dxi-column>
  <dxi-column dataField="NombreComercio" caption="Comercio" alignment="left"></dxi-column>
  <dxi-column dataField="ClaveMovimientoDescripcion" caption="Movimiento" alignment="left"></dxi-column>
  <dxi-column dataField="ReferenciaNumerica" caption="Referencia" alignment="center"></dxi-column>
  <dxi-column dataField="dateCreated" caption="Fecha" dataType="date" format="dd/MM/yyyy hh:mm a" alignment="center"></dxi-column>
  -->
  <dxi-column dataField="amount" caption="Importe" dataType="cureency" format="currency" alignment="right">
    <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
  </dxi-column>

  <!-- Columns Templates -->
  <div *dxTemplate="let data of 'posTemplate'">
    <span>{{ data.rowIndex + 1 }}</span>
  </div>
  <div *dxTemplate="let data of 'idTemplate'">
    <span>{{ data.value.id}}</span>
  </div>
  <div *dxTemplate="let data of 'tipoTemplate'">
    <span>{{ data.value.dispersionTypeName }}</span>
  </div>
  <div *dxTemplate="let data of 'dateCreatedTemplate'">
    <span>{{ getDate(data.value.dateCreated, 'YYYYMMDD', 'YYYY-MMM-DD') }}</span>
  </div>
  <div *dxTemplate="let data of 'dateScheduledTemplate'">
    <span>{{ getDate(data.value.dateScheduled, 'YYYYMMDD', 'YYYY-MMM-DD') }}</span>
  </div>
  <div *dxTemplate="let data of 'dateExecutedTemplate'">
    <span>{{ getDate(data.value.dateExecuted, 'YYYYMMDD', 'YYYY-MMM-DD') }}</span>
  </div>
  <div *dxTemplate="let data of 'TarjetaTemplate'">
    <i class="far fa-credit-card mr-2"></i>
    <span>**** **** **** {{data.value}}</span>
  </div>


  <!-- Detail -->
  <dxo-master-detail [enabled]="true" template="url" ></dxo-master-detail>
  <div *dxTemplate="let data of 'url'">
    <div class="master-detail-caption" *ngFor="let item of parseFiles(data.data.urls); trackBy: trackByFn;">
      <a (click)="dowloadVoucher(item, $event)" [href]="item.url" target="_blank">
        <i class="fal fa-file-alt"></i>
        {{ item.name }}
      </a>
    </div> 
  </div>
</dx-data-grid>